export default __webpack_public_path__ + "static/media/dzungla1.660a7b2a.jpg";